/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statement_Tree_Create_DescriptionInputs */

const en_statement_tree_create_description = /** @type {(inputs: Statement_Tree_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A statement tree is published as soon as it is created, so the source query must be valid and both statements need rows.`)
};

const nl_statement_tree_create_description = /** @type {(inputs: Statement_Tree_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een stamboom wordt direct bij het aanmaken gepubliceerd, dus de bronquery moet geldig zijn en beide overzichten hebben rijen nodig.`)
};

/**
* | output |
* | --- |
* | "A statement tree is published as soon as it is created, so the source query must be valid and both statements need rows." |
*
* @param {Statement_Tree_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_tree_create_description = /** @type {((inputs?: Statement_Tree_Create_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Tree_Create_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_tree_create_description(inputs)
	return en_statement_tree_create_description(inputs)
});